import Axios from "axios";

const API_URL_V3 = process.env.API_URL + "/api/v3/data/addresses/";

class Kelurahan {
  index(district_id) {
    return Axios.get(API_URL_V3 + `subdistricts?district_id=${district_id}&order_column=name&order_direction=asc`);
  }

  show(sub_district_id) {
    return Axios.get(API_URL_V3 + `subdistricts/${sub_district_id}`);
  }
}

export default new Kelurahan();



// WEBPACK FOOTER //
// ./src/api/daerahindonesia/kelurahan.js